import React, { useRef, useEffect } from 'react';

export const VideoSection = ({ src, children, overlay = 0.5, height = '80vh', sticky = false }) => {
  const videoRef = useRef(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (videoRef.current) {
          if (entry.isIntersecting) {
            videoRef.current.play().catch(() => {});
          } else {
            videoRef.current.pause();
          }
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={sectionRef}
      className={`relative overflow-hidden ${sticky ? 'sticky top-0' : ''}`}
      style={{ height }}
    >
      <video
        ref={videoRef}
        className="absolute inset-0 w-full h-full object-cover"
        src={src}
        muted
        loop
        playsInline
        preload="metadata"
      />
      <div className="absolute inset-0" style={{ backgroundColor: `rgba(10, 34, 53, ${overlay})` }} />
      <div className="relative z-10 h-full flex items-center justify-center">
        {children}
      </div>
    </div>
  );
};
